import React, { forwardRef, useContext } from "react";
import { VenueConfigContext } from "../context/VenueConfigContext";
const API_URL = process.env.REACT_APP_API_URL;
const BookingSlip = forwardRef(({ data }, ref) => {
  console.log("SLIP DATA:", data);
  const today = new Date().toLocaleDateString();
  // const balance = (Number(data.total) || 0) - (Number(data.advance) || 0);
  const { config, loading } = useContext(VenueConfigContext);

  if (loading) return null;
  // if (!config) return <div>Config not available</div>;
  console.log(config);
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    if (isNaN(d)) return "-";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const formatTime = (time) => {
    if (!time) return "-";

    const [hour, minute] = time.split(":");
    let h = parseInt(hour, 10);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12;
    h = h ? h : 12;

    return `${h}:${minute} ${ampm}`;
  };

  // Future-proof: later replace with config.TaxPercentage
  const subtotal = Number(data.total) || 0;
  const advancePaid = Number(data.advance) || 0;
  /* TAX DATA COMES FROM SUMMARY */

  const taxBreakdown = data.taxBreakdown || [];

  const totalTax = taxBreakdown.reduce((sum, t) => sum + Number(t.amount), 0);

  const grandTotal = subtotal + totalTax;
  const balance = grandTotal - advancePaid;

  return (
    <div
      ref={ref}
      style={{
        width: "794px",
        minHeight: "1123px",
        margin: "0 auto",
        padding: "40px",
        fontFamily: "'Lato', sans-serif",
        backgroundColor: "#ffffff",
        color: "#1f2937",
      }}
    >
      {/* HEADER WITH LOGO */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "25px",
        }}
      >
        <img
          src={`${API_URL}/logo.png?v=${Date.now()}`}
          alt="Logo"
          style={{
            width: "70px",
            height: "70px",
            objectFit: "contain",
          }}
        />

        <div style={{ textAlign: "center" }}>
          <h1
            style={{
              margin: 0,
              fontSize: "32px",
              fontFamily: "'Playfair Display', serif",
              color: "#0f766e",
            }}
          >
            {config.Name}
          </h1>
          <p style={{ margin: "6px 0 0", fontSize: "14px", color: "#6b7280" }}>
            {config.Address}
          </p>
          <p style={{ margin: 0, fontSize: "14px", color: "#6b7280" }}>
            Phone: {config.Phone} | {config.Email}
          </p>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
          fontSize: "14px",
        }}
      >
        <div>
          <strong>Booking Code:</strong> {data.bookingCode || data.BookingCode || "-"}
        </div>
        <div>
          <strong>Generated On:</strong> {today}
        </div>
      </div>
      {/* TITLE BAR */}
      <div
        style={{
          textAlign: "center",
          background: "#0f766e",
          color: "white",
          padding: "10px",
          marginBottom: "8px",
          letterSpacing: "2px",
          fontWeight: "600",
          fontFamily: "'Montserrat', sans-serif",
          fontSize: "13px",
        }}
      >
        BOOKING CONFIRMATION
      </div>

      {/* META */}

      {/* DETAILS CARDS */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "5px",
        }}
      >
        <Card>
          <SectionTitle title="Guest Details" />
          <InfoRow label="Full Name" value={data.fullName} />
          <InfoRow label="Mobile" value={data.mobile} />
          <InfoRow label="Email" value={data.email} />
          <InfoRow label="City" value={data.city} />
        </Card>

        <Card>
          <SectionTitle title="Event Details" />
          <InfoRow
  label="Event Type"
  value={data.eventType || data.EventType || "-"}
/>
          <InfoRow label="Event Date" value={formatDate(data.eventDate)} />

          <InfoRow
            label="Time"
            value={`${formatTime(data.startTime)} - ${formatTime(data.endTime)}`}
          />
          <InfoRow label="Venue" value={data.hall} />
          <InfoRow label="Pax" value={data.guests} />
        </Card>
      </div>

      {/* PAYMENT CARD */}
      <div style={{ marginTop: "10px" }}>
        <Card>
          <SectionTitle title="Payment Summary" />
          <table width="100%" style={{ fontSize: "14px" }}>
            <tbody>
              <Row label="Subtotal" value={`₹${subtotal.toFixed(2)}`} />

              {taxBreakdown.map((tax, index) => {
  const name = tax.name || tax.TaxName || "GST";
  const percent = tax.percent || tax.Percentage || 0;
  const amount = Number(tax.amount || 0);

  return (
    <Row
      key={index}
      label={`${name} (${percent}%)`}
      value={`₹${amount.toFixed(2)}`}
    />
  );
})}

              <tr
                style={{
                  borderTop: "1px solid #e5e7eb",
                  fontWeight: "600",
                }}
              >
                <td style={{ paddingTop: "8px" }}>Grand Total</td>
                <td style={{ textAlign: "right" }}>₹{grandTotal.toFixed(2)}</td>
              </tr>

              <Row label="Advance Paid" value={`₹${advancePaid.toFixed(2)}`} />

              <tr
                style={{
                  borderTop: "2px solid #e5e7eb",
                  fontWeight: "700",
                  fontSize: "15px",
                }}
              >
                <td style={{ paddingTop: "8px" }}>Balance Due</td>
                <td style={{ textAlign: "right", color: "#b91c1c" }}>
                  ₹{balance.toFixed(2)}
                </td>
              </tr>
            </tbody>
          </table>
        </Card>
      </div>

      {/* SERVICES CARD */}
      <div style={{ marginTop: "5px" }}>
        <Card>
          <SectionTitle title="Included Services" />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr 1fr",
              gap: "8px",
              fontSize: "14px",
            }}
          >
            {data.catering && <ServiceItem text="Catering" />}
            {data.decoration && <ServiceItem text="Decoration" />}
            {data.stageSetup && <ServiceItem text="Stage Setup" />}
            {data.dj && <ServiceItem text="DJ Service" />}
            {data.photography && <ServiceItem text="Photography" />}
            {data.parking && <ServiceItem text="Parking" />}
          </div>
        </Card>
      </div>

      {/* SIGNATURE */}
      <div
        style={{
          marginTop: "60px",
          display: "flex",
          justifyContent: "space-between",
          fontSize: "13px",
        }}
      >
        <Signature label="Guest Signature" />
        <Signature label="Authorized Signatory" />
      </div>

      <div
        style={{
          marginTop: "30px",
          textAlign: "center",
          fontSize: "12px",
          color: "#6b7280",
        }}
      >
        This is a computer-generated confirmation. No signature required.
      </div>
    </div>
  );
});

/* COMPONENTS */

const Card = ({ children }) => (
  <div
    style={{
      background: "#f9fafb",
      padding: "20px",
      borderRadius: "10px",
      border: "1px solid #e5e7eb",
    }}
  >
    {children}
  </div>
);

const SectionTitle = ({ title }) => (
  <div
    style={{
      marginBottom: "12px",
      fontWeight: "600",
      fontSize: "13px",
      fontFamily: "'Montserrat', sans-serif",
      letterSpacing: "1.5px",
      textTransform: "uppercase",
      color: "#0f766e",
    }}
  >
    {title}
  </div>
);

const InfoRow = ({ label, value }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "8px",
    }}
  >
    <span style={{ color: "#6b7280" }}>{label}</span>
    <span style={{ fontWeight: "500" }}>{value || "-"}</span>
  </div>
);

const Row = ({ label, value }) => (
  <tr>
    <td style={{ padding: "6px 0", color: "#6b7280" }}>{label}</td>
    <td style={{ textAlign: "right", fontWeight: "500" }}>{value}</td>
  </tr>
);

const ServiceItem = ({ text }) => (
  <div style={{ fontWeight: "500" }}>• {text}</div>
);

const Signature = ({ label }) => (
  <div style={{ textAlign: "center" }}>
    <div style={{ marginBottom: "6px" }}>___________________________</div>
    {label}
  </div>
);

export default BookingSlip;
